import { render, staticRenderFns } from "./Teclado.vue?vue&type=template&id=306b58a8&scoped=true&"
import script from "./Teclado.vue?vue&type=script&lang=js&"
export * from "./Teclado.vue?vue&type=script&lang=js&"
import style0 from "./Teclado.vue?vue&type=style&index=0&id=306b58a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306b58a8",
  null
  
)

export default component.exports